import { Injectable } from '@angular/core';
import { Http, Response, Headers, ResponseContentType } from '@angular/http';
import { Observable } from 'rxjs/Observable';
import { CONFIGURATION } from '../app.config';

@Injectable()
export class DetailpayrolleditService {

  private api_url = CONFIGURATION.baseServiceUrl + 'DetailPayrollEdit/';
  private _ssnUrl = CONFIGURATION.baseServiceUrl + 'SsnInfo/';

  constructor(private _http: Http) { }

  getReferenceData(data: any) {
    const headers = new Headers();
    headers.append('Client-Id', 'REPORTING-PORTAL-API-CLIENT');
    headers.append('Client-Secret', '0667b514-28a8-4928-9aa4-1ffe290ebcd2');
    return this._http.post(this.api_url + 'reference-data', data, { headers: headers })
      .map((response: Response) => response.json())
      .catch(this.handleError);
  }
  referencedata(data: any): Observable<any> {
    const headers = new Headers();
    headers.append('Client-Id', 'REPORTING-PORTAL-API-CLIENT');
    headers.append('Client-Secret', '0667b514-28a8-4928-9aa4-1ffe290ebcd2');
    return this._http.post(this.api_url + 'reference-data', data, { headers: headers })
      .map((response: Response) => response.json())
      .catch(this.handleError);
  }
  reportData(data: any): Observable<any> {
    const headers = new Headers();
    headers.append('Client-Id', 'REPORTING-PORTAL-API-CLIENT');
    headers.append('Client-Secret', '0667b514-28a8-4928-9aa4-1ffe290ebcd2');
    return this._http.post(this.api_url + `report-data`, data, { headers: headers })
      .map((response: Response) => response.json())
      .catch(this.handleError);
  }
  downloadExcel(filterCriteria: any): Observable<any> {
    const headers = new Headers();
    headers.append('Client-Id', 'REPORTING-PORTAL-API-CLIENT');
    headers.append('Client-Secret', '0667b514-28a8-4928-9aa4-1ffe290ebcd2');
    return this._http.post(this.api_url + 'excel-download', filterCriteria, { headers: headers, responseType: ResponseContentType.Blob }).map(
      (res) => {
        const a = document.createElement('a');
        document.body.appendChild(a);
        const blob = new Blob([res.blob()], { type: 'application/zip' });
        const downloadUrl = URL.createObjectURL(blob);
        window.open(downloadUrl);
      })
  }
  downloadPDFReport(filterCriteria: any): any {
    const headers = new Headers();
    headers.append('Client-Id', 'REPORTING-PORTAL-API-CLIENT');
    headers.append('Client-Secret', '0667b514-28a8-4928-9aa4-1ffe290ebcd2');
    return this._http.post(this.api_url + 'pdf-download', filterCriteria, { headers: headers, responseType: ResponseContentType.Blob }).map(
      (res) => {
          var link = document.createElement('a');
          let blob = new Blob([res.blob()], {
            type: 'application/zip' // must match the Accept type
          });
          link.href = window.URL.createObjectURL(blob);
          link.click();
          window.URL.revokeObjectURL(link.href);
      })
  }
  private handleError(error: Response) {
    // in a real world app, we may send the server to some remote logging infrastructure
    // instead of just logging it to the console
    console.error(error);
    return Observable.throw(error.json().error || 'Failed in web api(Server error) ');
  }
  getSSnData(ssnData: any): Observable<any[]> {
    const headers = new Headers();
    headers.append('Client-Id', 'REPORTING-PORTAL-API-CLIENT');
    headers.append('Client-Secret', '0667b514-28a8-4928-9aa4-1ffe290ebcd2');
    let fileName = 'ssnreportdata?Ssn=' + ssnData.ssn
      + '&TaxYear=' + ssnData.taxyear
      + '&ControlGroup=' + ssnData.controlgroup
      + '&ReportName=' + 'PayDayFederalReport';
    return this._http.get(this._ssnUrl + fileName, { headers: headers })
      .map((response: Response) => response.json())
      .catch(this.handleError);
  }
  getMultiselectDropdownSettings(type = ''){
    let settings = {
      singleSelection: false,
      searchPlaceholderText: 'Select',
      selectAllText: 'Select All',
      unSelectAllText: 'UnSelect All',
      enableSearchFilter: true,
      badgeShowLimit: 2,
      noDataLabel: ''
    }
    if(type == 'nodata'){
      settings.noDataLabel = 'No data found'
      return settings
    }else if (type == 'loading'){
      settings.noDataLabel = 'Please wait while loading data...'
      return settings
    }else{
      return settings
    }
  }
  mapOrder (listValues, selectedValues) {
    let newArray = []
    listValues = listValues.filter((elem) => !selectedValues.find(({ itemName }) => elem.itemName === itemName));
    newArray = newArray.concat(selectedValues)
    newArray = newArray.concat(listValues)
    return newArray
    };
}



// WEBPACK FOOTER //
// ./src/app/detailpayrolledit/detailpayrolledit.service.ts